module.exports = __webpack_public_path__ + "static/img/userule5.526c6a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userule5.jpg
// module id = IT2T
// module chunks = 0